interface StudentData {
  id: string;
  firstName: string;
  lastName: string;
}
export const sortByLastThenFirst = (a: StudentData, b: StudentData) =>
  (a.lastName || '').localeCompare(b.lastName || '', undefined, { sensitivity: 'base' }) ||
  (a.firstName || '').localeCompare(b.firstName || '', undefined, { sensitivity: 'base' });
